import { z } from "zod";

export const AuthV2Session = z.object({
  id: z.string(),
  refreshToken: z.string(),
  expiresAt: z.coerce.date(),
  createdAt: z.coerce.date(),
});

export type AuthV2Session = z.infer<typeof AuthV2Session>;
